// extracted by mini-css-extract-plugin
export default {"container":"src-layout-Components-SalesChannel-SalesChannelStatusIcon__container--TOGzW"};